<template>
  <div id="chart">
    <div>
      <div style="width: 12px; height: 12px; display: inline-block; border: 2px solid #826af9; border-radius: 100px; margin-right: 7px;"></div>
      <span style="color: #757575; font-size: 14px;">{{ title }}</span>
      <span style="color: #2c2c2c; font-size: 24px; font-weight: 500; margin-left: 5px;">{{ currentValue }}{{ unit }}</span>
    </div>
    <apexchart type="bar" :height="height" :options="chart.chartOptions" :series="chart.series"></apexchart>
  </div>
</template>

<script>
export default {
  name: 'HorizontalSingleBarGraph',
  props:{
    data1: Array,
    data2: Array,
    height: {
      type: Number,
      default: () => {
        return 90;
      }
    },
    title: {
      type: String,
      default: '금년 집행률 '
    },
    labels: {
      type: Array,
      default: () => {
        return []
      }
    },
    max: Number,
    currentValue: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      efault: '%'
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    columnWidth: {
      type: String,
      default: '45%'
    }
  },
  computed: {
    chart () {
      const unit = this.unit
      const max = Math.max(this.max, 5)
      return {
        series: [
          {
            name: '금년 실적',
            data: [this.currentValue]
          }
        ],
        chartOptions: {
          chart: {
            type: 'bar',
          },
          plotOptions: {
            bar: {
              horizontal: true,
              columnWidth: this.columnWidth,
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 4,
          },
          fill: {
            opacity: 1
          },
          yaxis: {
            tickAmount: 5,
            max,
            labels: {
              formatter (value) {
                const str = `${value}`
                if (str && str.length > 0) {
                  return str.replace(/,/gi, '').replace(/\B(?=(\d{3})+(?!\d))/gi, ',') + unit
                }
              }
            },
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}`.replace(/,/gi, '').replace(/\B(?=(\d{3})+(?!\d))/gi, ',') + unit
              }
            }
          },
          colors: ['#826AF9', '#CDCDCD'],
          labels: this.labels,
        },
      }
    }
  }
}
</script>

<style scoped>

</style>
